<h1 class="stock-title">Stock - Open Requests</h1>

<app-breadcrumb></app-breadcrumb>

<br/>
<div class="mt-3"></div>
<br/>
<div class="content_bg styled-section">
    <table class="scrollable-table">
        <ds-tabs>
            <ds-tabs-label for="open" (click)="onOpenTabClick(); $event.preventDefault()">
                Open Demo Requests
            </ds-tabs-label>
            <ds-tabs-content id="open">
                <div class="tab-content">
                    <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
                        <div class="table-section">
                            <div class="table-scroll-container">
                                <table *ngIf="rowsData.length > 0" class="ds-table zebra-table fixed-header-table">
                                    <thead class="table-head">
                                    <tr>
                                        <th>Image</th>
                                        <th>VIN</th>
                                        <th>Model Code</th>
                                        <th>Description</th>
                                        <th>Purpose</th>
                                        <th>Date Requested</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let row of rowsData">
                                        <td>
                                            <div class="image-popup-wrapper">
                                                @if (row['image'] === '') {
                                                    <ds-progress-circle
                                                            size="sm"
                                                            class="image-loader"
                                                    ></ds-progress-circle>
                                                } @else {
                                                    <img
                                                            [src]="row['image'] || 'image placeholder'"
                                                            alt="Image"
                                                            width="80"
                                                    />
                                                    <div class="image-hover-popup">
                                                        <img [src]="row['image']" alt="Vehicle Enlarged View"/>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <a
                                                    [href]="row['VIN'] | unitOverviewLink"
                                                    target="_blank"
                                                    rel="noopener"
                                                    style="
                    font-weight: bold;
                    color: #037493;
                    text-decoration: none;
                    cursor: pointer;
                  "
                                                    title="View Unit Overview"
                                            >
                                                {{ row['VIN'] }}
                                            </a>
                                        </td>
                                        <td>{{ row['modelCode'] }}</td>
                                        <td>{{ row['description'] }}</td>
                                        <td>{{ row['purpose'] }}</td>
                                        <td>{{ row['dateRequested'] }}</td>
                                        <td>
                    <span>
                      <ds-icon
                              icon="close"
                              size="md"
                              (click)="openCancelRequestConfirmationModal(row['VIN'])"
                              role="button"
                              tabindex="0"
                              style="cursor: pointer; color: #037493;"
                              title="Cancel Request"
                      ></ds-icon>
                      </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ds-tabs-content>

            <ds-tabs-label
                    for="cancelled"
                    (click)="onCancelledTabClick(); $event.preventDefault()"
            >
                Cancelled Demo Requests
            </ds-tabs-label>
            <ds-tabs-content id="cancelled">
                <div class="tab-content">
                    <ng-container
                            *ngIf="rowsData && rowsData.length > 0; else notYetSearched"
                    >
                        <div class="table-section">
                            <div class="table-scroll-container">
                                <table *ngIf="rowsData.length > 0" class="ds-table zebra-table">
                                    <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>VIN</th>
                                        <th>Model Code</th>
                                        <th>Description</th>
                                        <th>Purpose</th>
                                        <th>Date Requested</th>
                                        <!--              <th></th>-->
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let row of rowsData">
                                        <td>
                                            <div class="image-popup-wrapper">
                                                <img
                                                        [src]="row['image'] || 'image placeholder'"
                                                        alt="Image"
                                                        width="80"
                                                />
                                                <div class="image-hover-popup">
                                                    <img [src]="row['image']" alt="Vehicle Enlarged View"/>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <a
                                                    [href]="row['VIN'] | unitOverviewLink"
                                                    target="_blank"
                                                    rel="noopener"
                                                    style="
                    font-weight: bold;
                    color: #037493;
                    text-decoration: none;
                    cursor: pointer;
                  "
                                                    title="View Unit Overview"
                                            >
                                                {{ row['VIN'] }}
                                            </a>
                                        </td>
                                        <td>{{ row['modelCode'] }}</td>
                                        <td>{{ row['description'] }}</td>
                                        <td>{{ row['purpose'] }}</td>
                                        <td>{{ row['dateRequested'] }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ds-tabs-content>
        </ds-tabs>
    </table>
</div>
<br/>
<div class="mt-3"></div>
<br/>

<ds-modal
    #cancelRequestConfirmationModal
    [ds-modal-trigger-for]="cancelRequestConfirmationModal"
    [(isModalOpen)]="isCancelRequestModal"
    [dimensionsConfig]="{ width: '520px' }"
    [detachFooter]="true"
>
    <ds-box-header style="font-size: xx-large; font-weight: bold">
        Cancel Request Confirmation
    </ds-box-header>
    <ds-box-content>
        <p>
            Are you sure you want to cancel the demo replenishment request for this
            vehicle: <b>{{ cancelRequestModalData.vin }}</b> .
        </p>
    </ds-box-content>
    <ds-box-footer >
        <button
                ds-button
                style="
        background-color: white;
        color: rgb(3, 116, 147);
        padding: 5px 8px;
        margin-right: 8px;
        border-radius: 3px;
        border: 1px solid;
        height: 36px;
        min-width: 70px;
      "
                (click)="close()"
        >
            Cancel
        </button>
        <button
                ds-button
                style="
        background-color: #037493;
        color: white;
        padding: 5px 8px;
        border-radius: 3px;
        border: 1px solid #037493;
        height: 36px;
        min-width: 70px;
      "
                (click)="confirmCancelRequest()"
        >
            Confirm
        </button>
    </ds-box-footer>
</ds-modal>
<ng-template #notYetSearched>
    <div
            class="no-data-message"
            style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      width: 150vh;
      text-align: center;
      padding-left: 2rem;
    "
    >
        <div>
            <h1 style="margin: 0">NO CANCELLED DEMO RESULTS FOUND</h1>
            <p style="margin: 0">
                Use the filters and click 'Search' to find what you need.
            </p>
        </div>
    </div>
</ng-template>
<ng-template #noStock>
    <div
            class="no-data-message"
            style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      width: 150vh;
      text-align: center;
      padding-left: 2rem;
    "
    >
        <div>
            <h1 style="margin: 0">NO OPEN DEMO RESULTS FOUND</h1>
            <p style="margin: 0">
                Try adjusting your search criteria in the filters.
            </p>
        </div>
    </div>
</ng-template>
